import { QueryKey } from '@tanstack/react-query';
import { useModal } from 'context/Modal/Context';
import { MODAL_NAME } from 'context/Modal/MODAL_NAME';
import { CardDetailsWithStats } from 'hooks/queries/cards/useCardsDetailsApi';
import useUserApi from 'hooks/UserApi/useUserApi';
import useUserList from 'hooks/useUserList/useUserList';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { UseCardActionsType } from './type';

const useCardActions = ({
  reference,
  cardId,
}: {
  cardId?: string;
  reference?: string;
  queryKey: QueryKey;
}): UseCardActionsType => {
  const { openModal } = useModal();
  const { toggleCardWantlist } = useUserList('wantlist');
  const { push } = useRouter();
  const { t } = useTranslation();
  const { user } = useUserApi();

  const handleClickWantlist = (isInWantlist?: boolean) => {
    toggleCardWantlist(cardId, isInWantlist);
  };

  const handleAddPrinting = () => {
    if (!reference) {
      throw new Error('no card id given');
    }
    openModal(MODAL_NAME.CONFIRM_MODAL, {
      content: (
        <div>
          <p>{t('you-can-find-this-card-in-pod')}</p>
          <p>{t('by-clicking-on-continue')}</p>
        </div>
      ),
      title: 'print',
      submitLabel: 'continue',
      onSubmit: () => push('/printing'),
    });
  };

  const handleApplyFoiler = () => {
    if (!reference) {
      throw new Error('no card id given');
    }
    openModal(MODAL_NAME.APPLY_FOILER, {
      reference,
    });
  };

  const handleClickGive = async () => {
    if (!reference) {
      throw new Error('no reference given');
    }
    openModal(MODAL_NAME.GIVE_CARD, {
      reference,
    });
  };

  const handleClickSell = async () => {
    if (!reference) {
      throw new Error('no reference given');
    }

    if (user?.walletActivated) {
      openModal(MODAL_NAME.MANAGE_OFFER, {
        reference,
      });
    } else {
      openModal(MODAL_NAME.CMS_MODAL, {
        cmsModalName: 'wallet-eligibility',
      });
    }
  };

  const handleTradeList = async (cardDetails: CardDetailsWithStats) => {
    if (!reference) {
      throw new Error('no reference given');
    }
    openModal(MODAL_NAME.ADD_TO_TRADELIST, {
      card: cardDetails,
    });
  };

  return {
    handleClickGive,
    handleAddPrinting,
    handleClickSell,
    handleClickWantlist,
    handleApplyFoiler,
    handleTradeList,
  };
};

export default useCardActions;
